import { styled } from '@mui/material/styles';
import { Box, Grid, Paper } from '@mui/material';

export const ModalOverlayPositioning = styled(Box)(({ theme, top, right }) => ({
  position: 'absolute',
  height: 'fit-content',
  zIndex: 15,
}));

export const SuccessOverlay = styled(ModalOverlayPositioning)(({ theme, top, right }) => ({
  [theme.breakpoints.down('md')]: {},
  [theme.breakpoints.up('md')]: {
    top: `calc(${top}px * 0.215)`,
    right: `calc(${right}px * 0.315)`,
  },
  [theme.breakpoints.up('lg')]: {
    ['@media(min-width: 2000px)']: {
      top: `calc(${top}px * 0.25)`,
      right: `calc(${right}px * 0.35)`,
    },
    ['@media(min-width: 2500px)']: {
      top: `calc(${top}px * 0.25)`,
      right: `calc(${right}px * 0.35)`,
    },
  },
}));

export const LogoutOverlay = styled(ModalOverlayPositioning)(({ theme, top, right }) => ({
  [theme.breakpoints.down('md')]: {
    top: `calc(${top}px * 0.07)`,
    right: `calc(${right}px * 0.05)`,
  },
  [theme.breakpoints.up('md')]: {
    top: `calc(${top}px * 0.1)`,
    right: `calc(${right}px * 0.024)`,
  },
  [theme.breakpoints.up('lg')]: {
    ['@media(min-width: 2000px)']: {
      top: `calc(${top}px * 1.25)`,
      right: `calc(${right}px * 2.4)`,
    },
    ['@media(min-width: 2500px)']: {
      top: `calc(${top}px * 1.5)`,
      right: `calc(${right}px * 2.8)`,
    },
  },
}));

export const NotificationOverlay = styled(ModalOverlayPositioning)(({ theme, top, right }) => ({
  [theme.breakpoints.down('md')]: {
    top: `calc(${top}px * 0.08)`,
    right: `calc(${right}px * 0.03)`,
  },
  [theme.breakpoints.up('md')]: {
    top: `calc(${top}px * 0.095)`,
    right: `calc(${right}px * 0.06)`,
  },
  [theme.breakpoints.up('lg')]: {
    ['@media(min-width: 2000px)']: {
      top: `calc(${top}px * 1.25)`,
      right: `calc(${right}px * 2.4)`,
    },
    ['@media(min-width: 2500px)']: {
      top: `calc(${top}px * 1.5)`,
      right: `calc(${right}px * 2.8)`,
    },
  },
}));

export const ModalNotificationDropDown = styled(Box)(({ theme }) => ({
  minWidth: 'fit-content',
  width: 'fit-content',
  background: 'white',
  marginTop: '10px',
  animation: 'rotateMenu 250ms ease-in',
  borderRadius: '15px',

  '&::-webkit-scrollbar': {
    width: '3px',
    background: 'transparent',
    height: '0px',
  },

  [theme.breakpoints.up('md')]: {
    minWidth: 'fit-content',
    width: 'fit-content',
    maxWidth: '450px',
    maxHeight: '550px',
  },
}));

export const NotificationGrid = styled(Grid)(({ theme }) => ({
  padding: '5px',
  [theme.breakpoints.up('xs')]: {
    width: '96vw',
  },

  [theme.breakpoints.up('md')]: {
    width: 'min-content',
  },
}));

export const NotificationCardStyling = styled(Box)(({ theme, width }) => ({
  width: `calc(${width}px * 0.75)`,
}));

export const NotificationContainer = styled(Box)(({ theme }) => ({
  minWidth: '365px',
  minHeight: '50px',
  width: 'inherit',
  right: '0px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
}));

export const PopupModalContainer = styled(Box)(({ theme }) => ({
  fontFamily: 'Nunito',
  textAlign: 'center',

  backgroundColor: 'white',
  border: '1px solid var( --background)',
  borderRadius: '10px',
  boxShadow: '0 8px 40px -12px rgba(0,0,0,0.3)',
  transition: '0.3s',
  margin: 'auto',
  padding: 30,

  [theme.breakpoints.down('md')]: {
    width: '100vw',
    maxWidth: '500px',
  },
  [theme.breakpoints.up('md')]: {
    width: '500px',
  },

  '&:hover': {
    boxShadow: '0 16px 70px -12.125px rgba(0,0,0,0.3)',
  },
}));

export const DeleteOverlay = styled(ModalOverlayPositioning)(({ theme, top, right }) => ({
  [theme.breakpoints.down('md')]: {
    top: `calc(${top}px * 0.315)`,
    right: `calc(${right}px * 0)`,
  },
  [theme.breakpoints.up('md')]: {
    top: `calc(${top}px * 0.215)`,
    right: `calc(${right}px * 0.315)`,
  },
  [theme.breakpoints.up('lg')]: {
    ['@media(min-width: 2000px)']: {
      top: `calc(${top}px * 0.25)`,
      right: `calc(${right}px * 0.35)`,
    },
    ['@media(min-width: 2500px)']: {
      top: `calc(${top}px * 0.25)`,
      right: `calc(${right}px * 0.35)`,
    },
  },
}));

export const CloseAllJobsOverlay = styled(ModalOverlayPositioning)(({ theme, top, right }) => ({
  [theme.breakpoints.down('md')]: {
    top: `calc(${top}px * 0.315)`,
    right: `calc(${right}px * 0)`,
  },
  [theme.breakpoints.up('md')]: {
    top: `calc(${top}px * 0.215)`,
    right: `calc(${right}px * 0.315)`,
  },
  [theme.breakpoints.up('lg')]: {
    ['@media(min-width: 2000px)']: {
      top: `calc(${top}px * 0.25)`,
      right: `calc(${right}px * 0.35)`,
    },
    ['@media(min-width: 2500px)']: {
      top: `calc(${top}px * 0.25)`,
      right: `calc(${right}px * 0.35)`,
    },
  },
}));

export const MobileNavigationOverlay = styled(ModalOverlayPositioning)(({ theme, top, right }) => ({
  [theme.breakpoints.down('md')]: {
    top: `calc(${top}px * 0.315)`,
    right: `calc(${right}px * 0)`,
  },
  [theme.breakpoints.up('md')]: {
    top: `calc(${top}px * 0.215)`,
    right: `calc(${right}px * 0.315)`,
  },
  [theme.breakpoints.up('lg')]: {
    ['@media(min-width: 2000px)']: {
      top: `calc(${top}px * 0.25)`,
      right: `calc(${right}px * 0.35)`,
    },
    ['@media(min-width: 2500px)']: {
      top: `calc(${top}px * 0.25)`,
      right: `calc(${right}px * 0.35)`,
    },
  },
}));

export const CenteredFullOverlay = styled(ModalOverlayPositioning)(({ theme, top, right }) => ({
  [theme.breakpoints.down('sm')]: {
    top: `calc(${top}px * 0.05)`,
    right: `calc(${right}px * 0.03)`,

    '& > div': {
      width: '94vw',
      height: '90vh',
      overflow: 'scroll',
    },

    '@media(max-height: 725px)': {
      top: `calc(${top}px * 0.02)`,
      right: `calc(${right}px * 0.02)`,

      '& > div': {
        width: '96vw',
        height: '96vh',
      },
    },
  },
  [theme.breakpoints.up('sm')]: {
    top: `calc(${top}px * 0.1)`,
    right: `calc(${right}px * 0.1)`,
    '& > div': {
      width: '80vw',
      height: '58vh',
      '@media(min-width: 1000px) and (min-height: 700px)': {
        height: '62vh',
      },
    },
  },
  [theme.breakpoints.up('md')]: {
    top: `calc(${top}px * 0.1)`,
    right: `calc(${right}px * 0.1)`,
    '& > div': {
      height: '80vh',
    },
  },
  [theme.breakpoints.up('lg')]: {
    right: `calc(${right}px * 0.25)`,
    '& > div': {
      width: '50vw',
    },

    ['@media(min-width: 2000px)']: {
      top: `calc(${top}px * 0.02)`,
      right: `calc(${right}px * 0.02)`,

      '& > div': {},
    },
    ['@media(min-width: 2500px)']: {
      top: `calc(${top}px * 0.02)`,
      right: `calc(${right}px * 0.02)`,

      '& > div': {},
    },
  },
}));

export const CenteredFullInterestOverlay = styled(ModalOverlayPositioning)(
  ({ theme, top, right }) => ({
    [theme.breakpoints.down('sm')]: {
      top: `calc(${top}px * 0.05)`,
      right: `calc(${right}px * 0.03)`,

      '& > div': {
        width: '94vw',
        height: '90vh',
        overflow: 'scroll',
      },

      '@media(max-height: 725px)': {
        top: `calc(${top}px * 0.02)`,
        right: `calc(${right}px * 0.02)`,

        '& > div': {
          width: '96vw',
          height: '96vh',
        },
      },
    },
    [theme.breakpoints.up('sm')]: {
      top: `calc(${top}px * 0.1)`,
      right: `calc(${right}px * 0.1)`,
      '& > div': {
        width: '80vw',
        height: '58vh',
        '@media(min-width: 1000px) and (min-height: 700px)': {
          height: '62vh',
        },
      },
    },
    [theme.breakpoints.up('md')]: {
      top: `calc(${top}px * 0.1)`,
      right: `calc(${right}px * 0.1)`,
      '& > div': {
        height: '80vh',
      },
    },
    [theme.breakpoints.up('lg')]: {
      right: `calc(${right}px * 0.25)`,
      '& > div': {
        width: '50vw',
      },

      ['@media(min-width: 2000px)']: {
        top: `calc(${top}px * 0.225)`,
        right: `calc(${right}px * 0.25)`,

        '& > div': {},
      },
      ['@media(min-width: 2500px)']: {
        top: `calc(${top}px * 0.02)`,
        right: `calc(${right}px * 0.02)`,

        '& > div': {},
      },
    },
  })
);

export const CenteredFullHelpOverlay = styled(ModalOverlayPositioning)(({ theme, top, right }) => ({
  [theme.breakpoints.down('sm')]: {
    top: `calc(${top}px * 0.05)`,
    right: `calc(${right}px * 0.03)`,

    '& > div': {
      width: '94vw',
      height: '90vh',
      overflow: 'scroll',
    },

    '@media(max-height: 725px)': {
      top: `calc(${top}px * 0.02)`,
      right: `calc(${right}px * 0.02)`,

      '& > div': {
        width: '96vw',
        height: '96vh',
      },
    },
  },
  [theme.breakpoints.up('sm')]: {
    top: `calc(${top}px * 0.1)`,
    right: `calc(${right}px * 0.1)`,
    '& > div': {
      width: '80vw',
      height: '58vh',
      overflowY: 'scroll',
      [`&::-webkit-scrollbar`]: {
        width: '7.5px',
        height: '0px',
      },

      [`&::-webkit-scrollbar-track`]: {
        background: '#ededed',
        borderRadius: '15px',
      },

      [`&::-webkit-scrollbar-thumb`]: {
        background: '#888',
        borderRadius: '15px',
      },

      [`&::-webkit-scrollbar-thumb:hover`]: {
        background: '#555',
      },

      [`&::-webkit-scrollbar-button:end`]: {
        height: '5px',
        width: '30%',
      },
      [`&::-webkit-scrollbar-button:start`]: {
        height: '5px',
        width: '30%',
      },
      '@media(min-width: 1000px) and (min-height: 700px)': {
        height: '62vh',
      },
    },
  },
  [theme.breakpoints.up('md')]: {
    top: `calc(${top}px * 0.1)`,
    right: `calc(${right}px * 0.1)`,
    '& > div': {
      height: '80vh',
      overflowY: 'scroll',
    },
  },
  [theme.breakpoints.up('lg')]: {
    right: `calc(${right}px * 0.25)`,
    '& > div': {
      width: '50vw',
    },

    ['@media(min-width: 2000px)']: {
      top: `calc(${top}px * 0.08)`,
      right: `calc(${right}px * 0.225)`,

      '& > div': {},
    },
    ['@media(min-width: 2500px)']: {
      top: `calc(${top}px * 0.02)`,
      right: `calc(${right}px * 0.02)`,

      '& > div': {},
    },
  },
}));

export const CenteredMediumOverlay = styled(ModalOverlayPositioning)(({ theme, top, right }) => ({
  top: `calc(${top}px * 0.18)`,
  right: `calc(${right}px * 0.02)`,

  [theme.breakpoints.up('sm')]: {
    top: `calc(${top}px * 0.1)`,
    right: `calc(${right}px * 0.2)`,
  },
  [theme.breakpoints.up('md')]: {
    top: `calc(${top}px * 0.2)`,
    right: `calc(${right}px * 0.2)`,
  },
  [theme.breakpoints.up('lg')]: {},
}));
